// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type WarnIfPastDueFragment = {
  __typename?: "Organization";
  pastDue: boolean;
};

export const WarnIfPastDueFragmentDoc = gql`
  fragment WarnIfPastDue on Organization {
    pastDue
  }
`;
